import { useEffect } from "react";
import { MapPin, Mail, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ADDRESS, EMAIL } from "@/i18n";

const SECTIONS = [
  {
    id: "aviso",
    title: "Aviso legal",
    body: [
      "Titular del sitio: Asociación Juvenil de Baile K-house (K-HOUSE Dance Academy).",
      "La presente web tiene carácter informativo sobre las actividades de la asociación: clases de baile K-POP, eventos, workshops y actividades culturales en Santa Cruz de Tenerife.",
      "El uso de la web implica la aceptación de estas condiciones y de la política de privacidad.",
    ],
  },
  {
    id: "privacidad",
    title: "Política de privacidad",
    body: [
      "Los datos enviados a través de los formularios (inscripciones, contacto, workshop e información de reapertura de grupos) se utilizan exclusivamente para gestionar la solicitud y mantener la comunicación con la asociación.",
      "No cedemos datos a terceros. Nunca almacenamos datos de tarjeta: los pagos se procesan íntegramente en la pasarela de pago (SumUp).",
      "Las imágenes publicadas cuentan con la autorización de las personas participantes o de sus tutores legales, especialmente en el caso de menores.",
      "Puedes ejercer tus derechos de acceso, rectificación o supresión escribiendo a nuestro correo oficial.",
    ],
  },
  {
    id: "condiciones",
    title: "Condiciones de uso",
    body: [
      "La cuota mensual de socio debe abonarse dentro de los primeros 10 días naturales de cada mes a través de la pasarela de pago habilitada.",
      "Las inscripciones a workshops y actividades especiales tienen su propio proceso de inscripción y pago, y solo quedan confirmadas cuando se verifica el pago.",
      "Los horarios publicados pueden ajustarse durante el curso; cualquier cambio se comunica por los canales oficiales de la asociación.",
      "Queda prohibido el uso comercial de los contenidos y fotografías de esta web sin autorización expresa de la asociación.",
    ],
  },
];

export default function Legal() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Aviso legal | K-House Dance Academy";
    return () => {
      document.title = "K-house Dance Academy | Curso 2026/2027";
    };
  }, []);

  return (
    <div className="mx-auto max-w-3xl px-5 pb-24 pt-28 sm:px-8">
      <button
        data-testid="legal-back-button"
        onClick={() => navigate("/")}
        className="mb-8 inline-flex items-center gap-2 rounded-full border border-white/20 px-5 py-2.5 font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-zinc-300 transition-all duration-300 hover:border-accent hover:text-accent"
      >
        <ArrowLeft size={14} /> Volver al inicio
      </button>

      <h1 className="font-display text-3xl font-extrabold uppercase tracking-tight sm:text-4xl">Información legal</h1>

      <div className="mt-6 space-y-2 rounded-xl border border-white/10 bg-card p-5 text-sm text-zinc-300">
        <p className="flex items-center gap-2"><MapPin size={14} className="text-accent" /> {ADDRESS}</p>
        <p className="flex items-center gap-2"><Mail size={14} className="text-accent" /> {EMAIL}</p>
      </div>

      <div className="mt-10 space-y-12">
        {SECTIONS.map((s) => (
          <section key={s.id} id={s.id} data-testid={`legal-section-${s.id}`}>
            <h2 className="font-display text-xl font-extrabold uppercase tracking-tight text-accent sm:text-2xl">{s.title}</h2>
            <ul className="mt-4 space-y-3">
              {s.body.map((p, i) => (
                <li key={i} className="text-sm leading-relaxed text-zinc-300">{p}</li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </div>
  );
}